
import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: "bsx-select",
    label: "帳號類型",
    model: "type",
    required: true,
    values: [
      { id: "DEPT", name: "部門" },
      { id: "PERSONAL", name: "個人" },
    ],
    disabled: (model) => model.id,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '部門名稱',
    model: 'name',
    placeholder: '部門名稱',
    required: true,
    visible: (model) => model.type == 'DEPT',
    disabled: (model) => model.id,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '員工身分證字號',
    model: 'name',
    placeholder: '員工身分證字號',
    required: true,
    visible: (model) => model.type == 'PERSONAL',
    disabled: (model) => model.id,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-label',
    label: '姓名 / 所屬部門',
    model: 'staff_info_string',
    visible: (model) => model.id && model.type == 'PERSONAL',
  },
  {
    type: 'bsx-label',
    label: 'branch id',
    model: 'room_branch_id_string',
    visible: false,    
  },
  {
    type: 'x-relationCheckBoxField',
    label: '權限功能',
    model: 'permissions',
    required: true,
    style: 'matrix',
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/staff-center-feature-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-checklist',
    label: '房務管理/院區權限',
    model: 'permissions_room_branch',
    required: true,
    visible: function () {
      if(this.model.room_branch_id_string!=undefined){       
        var feature_room_branch_id = parseInt(this.model.room_branch_id_string);
        if(this.model.permissions!=undefined && this.model.permissions.indexOf(feature_room_branch_id)!=-1){      
          return true;
        }else{
          return false;       
        }
      }
      return false;
    },
    style: 'matrix',
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/room-hospital-branch-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {      
      this.validation();
    },
  },
];

export default fields;
